import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { VisitContainer } from '@/features/visits/containers/[visit-id]';

const visitSearchSchema = z.object({
  visitorId: z.coerce.number().int().positive().optional().catch(undefined),
});

export const Route = createFileRoute('/_layout/visits/$visitId')({
  component: VisitContainer,
  validateSearch: search => visitSearchSchema.parse(search),
});
